module.exports = __webpack_public_path__ + "static/media/26UNRWA9.a1c94434.jpg";